import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { RestService } from "@stdoutsrl/design-kit"
import {  Message } from "@stdoutsrl/design-kit";
import { LoaderService } from "../../service/loader.service";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styles: [],
  standalone: false,
})
export class FooterComponent implements OnInit {
  constructor(
    private router: Router,
    private rest: RestService,
    private loader: LoaderService,
    private message: Message,
    private activatedRoute: ActivatedRoute,
  ) {}


  ngOnInit(): void {
  //  setInterval(() => {
  //      this.snap()
  //  }, 2500);
  }

  snap() {
  const el:any = document.getElementById("target");
  const rect = el.getBoundingClientRect();
  const fragments = 40;

  el.classList.add("laser");

  for (let i = 0; i < fragments; i++) {
    const frag = document.createElement("div");
    frag.className = "fragment";

    const top = (rect.height / fragments) * i;
    frag.style.top = top + "px";

    // movimento casuale
    frag.style.setProperty("--x", (Math.random()*200-100) + "px");
    frag.style.setProperty("--y", (Math.random()*200-100) + "px");
    frag.style.setProperty("--r", (Math.random()*360) + "deg");

    frag.style.animation = `
      disintegrate 1.5s forwards ${i * 0.02}s,
      burn 1.5s forwards ${i * 0.02 + 0.5}s
    `;

    frag.textContent = el.textContent;

    el.appendChild(frag);
    setTimeout(() => {
      frag.remove()
    }, 1500);
  }

  // nasconde contenuto originale
  el.style.color = "transparent";
}
}
